<template>
    <div class="searchCombo">
        <topNav :title="title"></topNav>

        <commonInput @commitCarNum="searchCombo" :btntxt="'开票'"></commonInput>
    </div>
</template>
<script>
import topNav from "@/components/topnav/topnav"
import { Toast, Dialog } from 'vant';
import commonInput from "@/components/common/commonInput"
export default {
    name: 'searchCombo',
    components: {
        topNav,
        commonInput
    },
    data() {
        return {
            title: "电子发票",

        }
    },
    mounted() {
    },
    methods: {
        searchCombo(carNum) {//查询套餐
            this.commonUtil.setCookie("carNum2", carNum, 30)
            let appid = sessionStorage.getItem("appid");
            let commid = sessionStorage.getItem("commid");
            let parkingno = sessionStorage.getItem("parkingno");
            var query = {
                carNum: carNum,
                commid: commid,
                parkingno: parkingno,
                appid: appid,
                isHZ: 1
            }
            this.$router.push({ name: 'invoiceParkingPayRecord', query: query })
        }
    },
    created() {
        if(sessionStorage.getItem("commid")=='5CD00015'){
            this.title = "请录入车牌号码"
        }else{
            this.title = "电子发票"
        }
    },
    watch: {
    }


}
</script>
<style>
.searchCombo {
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/my/electronicInvoice/hzhospital.vue